export const tema = {
  warna: {
    primer: "#0f172a",
    primer_cerah: "#131c31",
    sekunder: "#7eadfc",
    putih: "#fff",
    hitam: "#000",
    teks: "#dcdcdc",
  },
  huruf: {
    keluarga: "DM Sans",
    ketebalan: {
      reguler: 400,
      sedang: 500,
      tebal: 700,
    },
  },
  titikhenti: {
    seluler: "768px",
    komputer: "1153px",
  },
};
